import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as InvoiceModalActions from 'web-app/react/modals-container/invoice/actions';

import AccountItem from './model';
import * as Actions from './actions';

const updateItems = (accountItems, newAccountItemId, updateFunc) => {
    return accountItems.update(newAccountItemId, AccountItem.default, updateFunc);
};

export default handleActions(
    {
        [Actions.insertItem.type]: (state, {payload}) => {
            const {item} = payload;

            return updateItems(state, item.id, () => AccountItem.fromAPI(item));
        },
        [Actions.fetchBillPayerBalanceSuccess.type]: (state, action) => {
            const invoicing = action.payload.invoicing;
            return state.merge(
                Map(
                    invoicing.items.reduce((object, item) => {
                        return {
                            ...object,
                            [item.id]: AccountItem.fromAPI(item),
                        };
                    }, {}),
                ),
            );
        },
        [Actions.fetchAllSuccess.type]: (state, action) => {
            const items = action.payload.items;
            return state.merge(
                Map(
                    items.reduce((object, item) => {
                        return {
                            ...object,
                            [item.id]: item,
                        };
                    }, {}),
                ),
            );
        },
        [Actions.createInvoiceSuccess.type]: (state, action) => {
            const {invoices} = action.payload;
            invoices.forEach(invoice => {
                state = updateItems(state, invoice.id, () => AccountItem.fromAPI(invoice));
            });
            return state;
        },
        [Actions.createInvoiceWithGraphQLSuccess.type]: (state, action) => {
            const {invoices} = action.payload;
            invoices.forEach(invoice => {
                state = updateItems(state, invoice.id, () => invoice);
            });
            return state;
        },
        [Actions.createPaymentSuccess.type]: (state, action) => {
            const payment = action.payload.newPayment;
            return updateItems(state, payment.id, () => AccountItem.fromAPI(payment));
        },
        [Actions.updatePaymentSuccess.type]: (state, action) => {
            const payment = action.payload.newPayment;
            const oldPayment = action.payload.oldPayment;
            return updateItems(state.delete(oldPayment.id), payment.id, () => AccountItem.fromAPI(payment));
        },
        [Actions.deletePaymentSuccess.type]: (state, action) => {
            const oldPayment = action.payload.oldPayment;
            return state.delete(oldPayment.id);
        },
        [InvoiceModalActions.cancelSuccess.type]: (state, {payload}) => {
            const {invoices} = payload;
            const newMap = Map().withMutations(map => {
                invoices.reduce((m, invoice) => {
                    return m.update(invoice.id, AccountItem.default, () => AccountItem.fromAPI(invoice));
                }, map);
            });
            return newMap.merge(state);
        },
    },
    Map(),
);
